<template>
  <modal
    :show.sync="isShowModal"
    modal-classes="modal-secondary"
    :backdrop-close="true"
    size="lg"
    @close="close()"
  >
    <h6 slot="header" class="modal-title text-uppercase">Add Invitation</h6>
    <validation-observer ref="formValidator">
      <div class="row">
        <div class="col-md-6">
          <base-input
            v-model="formGroup.name.value"
            :rules="formGroup.name.rule"
            label="Name"
            name="Name"
            placeholder="Enter name"
          ></base-input>
        </div>

        <div class="col-md-4">
          <base-input
            v-model="formGroup.phone.value"
            :rules="formGroup.phone.rule"
            label="Phone"
            name="phone"
            placeholder="Enter Phone No"
          ></base-input>
        </div>
      </div>
    </validation-observer>
    <template v-slot:footer>
      <base-button type="primary" :loading="loading" @click="saveAirport">
        Submit
      </base-button>
      <base-button
        class="ml-auto"
        type="primary"
        :outline="true"
        @click="close()"
      >
        Close
      </base-button>
    </template>
  </modal>
</template>

<script>
import { FormGroup } from "@/core/models";
import { invitationService, notificationService } from "@/core/services";
import { GRANT } from "@/core/enums";

export default {
  props: {
    showAddInvitaitionModalForm: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalState: false,
      formGroup: new FormGroup({
        name: [null, { required: true }],
        phone: [null, { required: true }],
      }),

      loading: false,
      GRANT: GRANT,
    };
  },
  computed: {
    isShowModal: {
      get() {
        return this.showAddInvitaitionModalForm;
      },
      set(value) {
        this.modalState = value;
      },
    },
  },
  methods: {
    async saveAirport() {
      const validate = await this.$refs.formValidator.validate();
      if (validate) {
        console.log(this.formGroup.value);
        this.loading = true;

        invitationService
          .save(this.formGroup.value)
          .then((res) => {
            notificationService.success(res.message);
            this.close();
          })
          .finally(() => (this.loading = false));
      }
    },
    close() {
      this.isShowModal = false;
      this.$emit("close");
      this.$refs.formValidator.reset();
      this.formGroup.reset();
      //console.log(this.formGroup);
    },
  },
};
</script>

<style lang="scss" scoped>
.heading-separator {
  border-bottom: 1px solid #968888;
  margin-bottom: 1.5em;
  margin-top: 1em;
}
</style>
